<template>
  <div class="asc-derived-parameter-details-template">
    <asc-derived-parameter-input-wrapper
      :airline-name="airlineName"
      :alert-type="alertType"
      :airline-id="airlineId"
      :parameter-name="parameterName"
      :platform-text="platformText"
      :is-single-airline-user="isSingleAirlineUser"
      @handleBlurParameterName="handleBlurParameterName"
      @handleChangeParameterName="handleChangeParameterName"
    />
    <asc-derived-parameters-expression-wrapper
      :allowed-characters="allowedCharacters"
      :logic-string-valid="logicStringValid"
      :validate-loading="validateLoading"
      :parameter-list="parameterList"
      :expression-options="expressionOptions"
      :is-full-flight="isFullFlight"
      :pdf-document="pdfGuide"
      :expression-input="logicStringText"
      @handleExpressionUpdated="handleExpressionUpdated"
      @handleLogicValidate="handleLogicValidate"
      @handleBlurParameterName="handleBlurParameterName"
    />
  </div>
</template>

<script>
import AscDerivedParametersExpressionWrapper from '@/components/organisms/AscDerivedParametersExpressionWrapper'
import AscDerivedParameterInputWrapper from '@/components/organisms/AscDerivedParameterInputWrapper'

export default {
  name: 'AscDerivedParameterDetailsTemplate',

  components: {
    AscDerivedParametersExpressionWrapper,
    AscDerivedParameterInputWrapper,
  },

  props: {
    airlineName: {
      type: String,
      default: '',
    },
    airlineId: {
      type: Number,
      default: null,
    },
    alertType: {
      type: String,
      required: true,
    },
    parameterName: {
      type: String,
      default: '',
    },
    logicStringText: {
      type: String,
      default: '',
    },
    pdfGuide: {
      type: String,
      default: '',
    },
    allowedCharacters: {
      type: Object,
      default: () => {},
    },
    expressionOptions: {
      type: Array,
      default: () => [],
    },
    parameterList: {
      type: Array,
      default: () => [],
    },
    logicStringValid: {
      type: Boolean,
      default: true,
    },
    validateLoading: {
      type: Boolean,
      default: false,
    },
    isFullFlight: {
      type: Boolean,
      default: true,
    },
    derivedParameter: {
      type: Object,
      default: () => {},
    },
    isSingleAirlineUser: {
      type: Boolean,
      default: false,
    },
    platformText: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleExpressionUpdated(value) {
      this.$emit('handleExpressionUpdated', value)
    },

    handleLogicValidate(value) {
      this.$emit('handleLogicValidate', value)
    },
    handleBlurParameterName(parameterName) {
      this.$emit('handleBlurParameterName', parameterName)
    },
    handleChangeParameterName(parameterName) {
      this.$emit('handleChangeParameterName', parameterName)
    },
  },
}
</script>
